import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import logo from '../logo.jpg';
import useSEO from '../hooks/useSEO';
import './StatusPage.css';

const StatusPage = ({ variant, icon, title, message }) => {
  useSEO({
    title: `${title} | MiEstampita`,
    description: message,
    path: `/${variant}`,
    noindex: true,
  });

  return (
  <div className="status-page">
    <div className="status-page__logo-wrapper">
      <Link to="/">
        <img src={logo} alt="MiEstampita Logo" className="status-page__logo" />
      </Link>
    </div>
    <div className={`status-page__card status-page__card--${variant}`}>
      <div className="status-page__icon" aria-hidden="true">
        {icon}
      </div>
      <h1 className="status-page__title">{title}</h1>
      <p className="status-page__message">{message}</p>
      <Link to="/" className="status-page__cta">
        Volver al inicio
      </Link>
    </div>
  </div>
  );
};

StatusPage.propTypes = {
  variant: PropTypes.oneOf(['success', 'failure', 'pending']).isRequired,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default StatusPage;
